import { useState } from "react";
import Navbar from "../Dashboard/Navbar";
import Report from "./Report";
import GeneralInfo from "./GeneralInfo";
import BusinessDetails from "./BusinessDetails";
import ValuationInfo from "./ValuationInfo";
import Disclosure from "./Disclosure";
import BVATabs from "../../components/BVATabs/BVATabs";

const REPORT_TAB = "REPORT_TAB";
const INFO_TAB = "INFO_TAB";
const DETAIL_TAB = "DETAIL_TAB";
const VAL_INFO_TAB = "VAL_INFO_TAB";
const DISCLOSURE_TAB = "DISCLOSURE_TAB";

const ReportPage = () => {
  const dashboardTabs = [
    { label: "Report Generation", value: REPORT_TAB },
    { label: "Company Info", value: INFO_TAB },
    { label: "Business Details", value: DETAIL_TAB },
    { label: "Valuation Info", value: VAL_INFO_TAB },
    { label: "Report Disclosures", value: DISCLOSURE_TAB },
  ];

  // State
  const [currentDashboardTab, setCurrentDashboardTab] = useState(REPORT_TAB);

  return (
    <>
      <Navbar />

      <div className="dashboard-container">
        <div className="px-10">
          <BVATabs
            items={dashboardTabs}
            value={currentDashboardTab}
            onChange={(dashboardTab) => setCurrentDashboardTab(dashboardTab)}
          />
        </div>
        <div className="mt-10 px-10 pb-10">
          {currentDashboardTab === REPORT_TAB ? (
            <Report />
          ) : null}

          {currentDashboardTab === INFO_TAB ? (
            <GeneralInfo />
          ) : null}

          {currentDashboardTab === DETAIL_TAB ? (
            <BusinessDetails />
          ) : null}

          {currentDashboardTab === VAL_INFO_TAB ? (
            <ValuationInfo />
          ) : null}

          {currentDashboardTab === DISCLOSURE_TAB ? (
            <Disclosure />
          ) : null}
        </div>
      </div>
    </>
  );
};

export default ReportPage;
